import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { combineStates, siteSettingsState, popupDispatcher,identityState, messageDispatcher, activeTabReducer } from '../../../store';
import { connect } from 'react-redux';
import { getAvailableLanguages, getLanguageKey, getLanguages, sessionStore, translate } from '../../../services';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { service } from '../../../services';
import '../../../../style/components/jira-support.less';
import { Box, Drawer, IconButton as MuiIconButton } from '@mui/material';
import { VectorArrowRightIconNew, closePopup } from '../../../../style/images';
import DashedTextFieldWithDrop from './DashedTextField';
import { Checkbox, FormControlLabel, Link } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'ABBvoice Regular',
  },
  overrides: {
    MuiInputBase: {
      input: {
        fontFamily: 'ABBvoice Regular',
      },
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          borderColor: '#BABABA',
        },
        '&:hover $notchedOutline': {
          borderColor: '#BABABA',
        },
        '&$focused $notchedOutline': {
          borderColor: '#BABABA',
        },
      },
    },
  },
});

export class JiraSupportComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      summaryError: false,
      emailError: false,
      hiddenText: true,
      windowData: "data",
      summary: "",
      email: "",
      description: "",
      checked: true,
      descriptionError: false,
      files: [] ,
      privacyPolicyAccepted: false,
      country: "", //honeypot field
      isSubmitting: false
    };
  }

  handlecountryChange = (event) => {
    this.setState({ country: event.target.value });
  };
  //for attachments clicking +
  handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const validFiles = newFiles.filter(file => file.size <= 2 * 1024 * 1024 * 1024); // 2GB limit
    if (this.state.files.length + validFiles.length <= 10) { // 10 files limit
      this.setState(prevState => ({
        files: [...prevState.files, ...validFiles]
      }));
    } else {
      this.props.addMessage({ timeout: 10000, messageText: translate('SupportPage.FileUploadLimit'), messageType: 'warning' });
    }
  };
  //for attachments drag and drop
  handleDrop = (event) => {
    event.preventDefault();
    const newFiles = Array.from(event.dataTransfer.files);
    const validFiles = newFiles.filter(file => file.size <= 2 * 1024 * 1024 * 1024); // 2GB limit
    if (this.state.files.length + validFiles.length <= 10) { // 10 files limit
      this.setState(prevState => ({
        files: [...prevState.files, ...validFiles]
      }));
    } else {
      this.props.addMessage({ timeout: 10000, messageText: translate('SupportPage.FileUploadLimit'), messageType: 'warning' });
    }
  };
  
  handleDelete = (index) => {
    this.setState(prevState => ({
      files: prevState.files.filter((_, i) => i !== index)
    }));
  };
  
  handleDeleteAll = () => {
    this.setState({ files: [] });
  };

  handleCheckboxChange = (event) => {
    this.setState({ privacyPolicyAccepted: event.target.checked });
  };
  
  SubmitData = () => {
    if (!this.state.summaryError && !this.state.emailError && !this.state.descriptionError && this.state.privacyPolicyAccepted && !this.state.country) {
      this.setState({isSubmitting:true})
      const files = this.state.files;
      const fileReaders = files.map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = reject;
        });
      });
  
      Promise.all(fileReaders).then(base64Files => {
        const jiraData = {
          description: this.state.description,
          summary: this.state.summary,
          url: sessionStore.get('history').slice(-1)[0]?sessionStore.get('history').slice(-1)[0]:"Url not available in Session Store",
          email: this.state.email,
          files: base64Files,
          country: this.state.country //this is a honeypot
        };
        
        service("jira")
          .post(jiraData)
          .then(response => {
          this.setState({ email: "", summary: "", description: "", files: [], privacyPolicyAccepted: false, country: "", isSubmitting:false });
          this.props.addMessage({ timeout: 10000, messageText: translate('SupportPage.TicketCreated'), messageType: 'confirmation' });
            
          })
          .catch(error => {
            console.error("Error creating ticket:", error);
            this.props.addMessage({ timeout: 10000, messageText: translate('SupportPage.CommunicationError'), messageType: 'error' });
            this.mounted && this.setState({ isAdding: false, isSubmitting:false });
          });
      }).catch(error => {
        console.error("Error converting files to Base64:", error);
        this.props.addMessage({ timeout: 10000, messageText: translate('SupportPage.AttachmentError'), messageType: 'error' });
        this.setState({ isAdding: false, isSubmitting:false })
      });
    }
    else {
      console.log("Form submission blocked due to country or validation errors.");
    }
  };
  
  validateSummary = (e) => {
    let summary = e.currentTarget.value;
    this.setState({ summary: e.currentTarget.value, summaryError: summary.length ? false : true });
  }

  validateEmail = (email) => {
    let Email = email.currentTarget.value;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let emailError = false;
    if (!regex.test(Email)) { emailError = true; }
    this.setState({ email: email.currentTarget.value, emailError: emailError });
  }

  descriptionData = (e) => {
    let description = e.currentTarget.value;
    this.setState({ description: e.currentTarget.value, descriptionError: description.length ? false : true });
  }

  

  isSubmitButtonDisabled = () => {
    return this.state.isSubmitting || this.state.emailError || this.state.summaryError || this.state.descriptionError ||
      !this.state.email || !this.state.summary || !this.state.description || !this.state.privacyPolicyAccepted || this.state.country;
  }

  openPopup = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false, emailError: false, summaryError: false, windowData: false, descriptionError: false, files: [], privacyPolicyAccepted: false, country:"" });
  }
  
  getCurrentLanguage(siteSettings, availableLanguages) {
    let currentLanguage;
    for (let lang in siteSettings.availableLanguages) {
      const value = getLanguageKey(lang);
      if (!availableLanguages.includes(value)) {
        continue;
      }
      currentLanguage = value === getLanguages().first() ? lang.toLowerCase().slice(0, 2) : currentLanguage;
    }
    return currentLanguage;
  }

  getBaseUrl(currentLanguage, user) {
    if (currentLanguage === 'de') {
      if (user.country.toLowerCase() === 'de') {
        return 'https://new.abb.com/privacy-policy/de/datenschutz-deutschland';
      } else if (user.country.toLowerCase() === 'ch') {
        return 'https://new.abb.com/privacy-policy/de/datenschutz-schweiz/datenschutzerklaerung-geschaeftspartner-schweiz';
      } else {
        return 'https://new.abb.com/privacy-policy/de';
      }
    } else {
      return currentLanguage === 'en' 
        ? 'https://new.abb.com/privacy-policy' 
        : `https://new.abb.com/privacy-policy/${currentLanguage}`;
    }
  }

  render() {
    const { siteSettings, user } = this.props;
    const availableLanguages = getAvailableLanguages();
    const currentLanguage = this.getCurrentLanguage(siteSettings, availableLanguages);
    const baseUrl = this.getBaseUrl(currentLanguage, user);
    const defaultUrl = "https://new.abb.com/default-privacy-policy";


    return (
      <ThemeProvider theme={theme}>
        <div style={{ cursor: "pointer", zIndex: 100 }} className={this.props.className}>
        <div
            title={translate('FEEDBACKTOOLTIP')}
            onClick={this.openPopup}
            className='primary-button'
          >
          <span>{translate('Support')}</span>
          </div>


          <form>
            <Dialog open={this.state.open} onClose={this.handleClose} PaperProps={{className:"dialog-fullscreen"}} >
              <div className="dialog-content" >
                <h2 className='support-title'>{translate('SupportPage.SupportRequest')}</h2>
                <p className='support-subtitle'>{translate('SupportPage.FillInEnglish')}</p>
                <DialogContent>
                  <TextField
                    error={this.state.summaryError}
                    helperText={this.state.summaryError && translate('SupportPage.SummaryMandatory')}
                    onChange={this.validateSummary}
                    required
                    autoFocus
                    margin="dense"
                    id="summary"
                    label={translate('SupportPage.Summary')}
                    type="Summary"
                    fullWidth
                    variant="outlined"
                  />
                  <TextField
                    error={this.state.emailError}
                    helperText={this.state.emailError && translate('SupportPage.EmailWrong')}
                    onChange={this.validateEmail}
                    required
                    autoFocus
                    margin="dense"
                    id="name"
                    label={translate('Email')}
                    type="email"
                    fullWidth
                    variant="outlined"
                  />
                  <TextField
                    error={this.state.descriptionError}
                    helperText={this.state.descriptionError && translate('SupportPage.DescriptionMandatory')}
                    onChange={this.descriptionData}
                    fullWidth
                    id="standard-multiline-static"
                    label={translate('Description')}
                    multiline
                    rows={6}
                    required
                    autoFocus
                    margin="dense"
                    type="Description"
                    variant="outlined"
                  />
                 <DashedTextFieldWithDrop
                    files={this.state.files}
                    onFileChange={this.handleFileChange}
                    onDrop={this.handleDrop}
                    onDelete={this.handleDelete}
                    onDeleteAll={this.handleDeleteAll}
                    addMessage={this.props.addMessage}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.privacyPolicyAccepted}
                        onChange={this.handleCheckboxChange}
                        name="privacyPolicy"
                        color="primary"
                        style={{color: 'red'}}
                      />
                    }
                    label={
                      <span>
                        {translate('SupportPage.AgreePrivacy')}
                        <a 
                          href={baseUrl} 
                          target="_blank"
                          onError={(event) => {
                            event.preventDefault();
                            window.open(defaultUrl, '_blank', 'noopener,noreferrer');
                          }} 
                          className="custom-link"
                        > {translate('Privacy Policy')}
                        </a>
                      </span>
                    }
                  />
                  {/* HONEYPOT field */}
                  <TextField
                    style={{ display: 'none' }}
                    id="country"
                    type="text"
                    value={this.state.country}
                    onChange={this.handlecountryChange}
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </DialogContent>
                <DialogActions>
                  <div className='secondary-button' onClick={this.handleClose}>
                  <span>{translate('Cancel')}</span>
                  </div>
                  <div 
                    className='primary-button' 
                    onClick={() => {
                      if (this.isSubmitButtonDisabled()) {
                        this.props.addMessage({ 
                          timeout: 10000, 
                          messageText: translate('SupportPage.FillRequiredFields'), 
                          messageType: 'warning' 
                        });
                      } else {
                        this.SubmitData();
                      }
                    }} 
                    style={{ pointerEvents: this.state.isSubmitting ? 'none' : 'auto' }} //managing pointer for not creating multiple tickets
                    disabled={this.state.isSubmitting || this.isSubmitButtonDisabled()}
                  >
                    <span>{translate('SupportPage.Send')}</span>
                  </div>
                </DialogActions>
              </div>
              <MuiIconButton onClick={this.handleClose} width="18px" height="18px" sx={{ position: "absolute", top: "12px", right: "12px", background: "transparent", height: "18px", width: "18px", borderRadius: "56px" }}>
                <Box component="img" style={{ width: "inherit", height: "inherit" }} src={closePopup}></Box>
              </MuiIconButton>
            </Dialog>
          </form>
        </div>
      </ThemeProvider>
    );
  }
}
JiraSupportComponent.propTypes = {
  siteSettings: PropTypes.shape( {
  emailToConfiguration: PropTypes.shape( {
    emailTo: PropTypes.string,
    subject: PropTypes.string,
    copyTo: PropTypes.string
  } )
} )
}

export const JiraSupport = connect( combineStates(  siteSettingsState,identityState ), messageDispatcher) (JiraSupportComponent) ;